import SvgIcon from "@mui/material/SvgIcon";

export const GrowDashOH2DIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 100 100">
        <path d="M89.998 49.9984L63.332 23.3315L36.663 49.9996L63.329 76.6665L89.998 49.9984Z" fill="#5D614F"/>
        <path d="M27.235 50L50.189 27.047C46.221 24.703 41.608 23.333 36.664 23.333C21.94 23.333 10 35.273 10 50C10 64.727 21.94 76.667 36.664 76.667C41.607 76.667 46.221 75.296 50.189 72.952L27.235 50Z" fill="#5D614F"/>
    </SvgIcon>
);